import styled, { css } from "styled-components";

import { T_TITLE_2 } from "../../global.style";

export const StyledErrorPage = styled.div<{ $inline?: boolean }>`
    ${props => props.$inline ? css`
        height: 100%;
    ` : css`
        height: calc(100vh / var(--zoom-correction));
        transform: translateY(-120px);
    `};
    min-height: 450px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    & > div {
        width: 400px;
        height: 400px;
    }
    & > h2 {
        ${T_TITLE_2};
        color: ${props => props.theme.C_ACT_thick_line};
        white-space: pre-wrap;
        text-align: center;
    }
`;